import s from './question-types.module.scss'

interface ITextoGraphicProps {
  question: any
}

const TextoGraphic = ({ question }: ITextoGraphicProps) => (
  <>
    {/* eslint-disable-next-line react/no-danger */}
    <div className={s.textoGraphic} dangerouslySetInnerHTML={{ __html: question?.text }} />
  </>
)

export default TextoGraphic
